import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'

class ConsultasFinal extends Component {
    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    <div className="listado" id="menu">
                        <h2 className='tituloAccion'>Consultas</h2>
                        <TableContainer>
                            <Table sx={{minWidth: 500}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><a href="./Informes-GenerarPDF">Generar Informe (PDF)</a></TableCell>
                                        <TableCell><a href="./MantArchivo-Asiduidad">Asiduidad</a></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><a href="./MantArchivo-Retroactivo">Retroactivo</a></TableCell>
                                        <TableCell><a href="./MantArchivo-Calificaciones">Calificaciones</a></TableCell>
                                    </TableRow>
                                    {/*<TableRow>
                                        <TableCell><a href="./Consultar-Organigrama">Organigrama</a></TableCell>
                                        <TableCell><a href="./login"></a></TableCell>
                                    </TableRow>*/}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                :
                    <Redirect to='/login'/>
                }
            </>
        )
    }
}

export default ConsultasFinal